import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'
import { combineReducers } from 'redux'

const normalizeSearchResults = data => {
  const presentations = new schema.Entity('presentations')
  return normalize(data, [presentations])
}

const PresentationSearchReducer = combineReducers({
  fetching: createRequestReducer('PRESENTATION_SEARCH:FETCH'),
  fetchingP365: createMappedRequestReducer(
    'PRESENTATION_SEARCH:FETCH_P365',
    (state, params, status) => {
      const { count, from } = params
      const newState = { ...state }
      const side = Math.floor(count / 2)
      for (let i = from - side; i <= from + side; i++) {
        newState[i] = status
      }
      return newState
    }
  ),
  filters: createReducer(null, {
    'PRESENTATION_SEARCH:FETCH_REQUEST_SUCCESS': (state, { params }) => ({
      ...state,
      search_string: params.search_string,
      from: params.from,
      limit: params.limit,
      year_group_ids: params.year_group_ids
    }),
    'PRESENTATION_SEARCH:RESET': state => null
  }),
  searchResults: createReducer(null, {
    'PRESENTATION_SEARCH:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeSearchResults(response.data.presentations),
    'PRESENTATION_SEARCH:RESET': state => null,
    'PRESENTATION_SEARCH:CHANGE_RECOMMENDED_REQUEST_SUCCESS': (
      state,
      { params }
    ) => ({
      ...state,
      entities: {
        presentations: {
          ...state.entities.presentations,
          [params.id]: {
            ...state.entities.presentations[params.id],
            recommended_until: params.date
          }
        }
      }
    })
  }),
  p365: createReducer(null, {
    'PRESENTATION_SEARCH:FETCH_P365_REQUEST_SUCCESS': (
      state,
      { response, params }
    ) => {
      const presentations = response.data.presentations
      const { count, from } = params
      const newState = { ...state }
      const range = Math.floor(count / 2)
      const shift = from - range
      presentations.forEach((presentation, index) => {
        newState[shift + index] = presentation
      })
      return newState
    }
  })
})

export default PresentationSearchReducer
